import React, { Fragment, useState } from "react";
import classnames from "classnames";
import { Overlay, Popover } from "react-bootstrap";
import ReactDOM from "react-dom";
import api from "../../../../api";
import {
  DateFormats,
  formatDate,
  ILeadActivity,
  useHasPermission,
  AppPermissions,
  Customer,
  getInvalidCustomerFieldsEnquiry,
  Lead,
  useLead360,
  capitalizeFirstLetter,
  TestDriveInititationStatuses,
} from "../../../../core";
import { useLeadActivities } from "../../../../core/hooks/useLeadActivities";
import { activityTypeToIconMapper } from "./add-activity";
import moment from "moment";
import { EventCancelForm } from "../../../calendar/components/event-cancel-form";
import { useCalendarContext } from "../../../../core/hooks/useCalendarContext";
import { Spinner } from "../../../../components/loader";
import { usePerformAction } from "react-remote-data-hooks";
import { toastr } from "react-redux-toastr";
import PdfDownloadButton from "../../../../components/pdf-download-button";

import logoImage from "../../../../assets/images/cancel.svg";
import { useMasterData } from "../../../../core/hooks/useMasterData";
import { useAppSettings } from "../../../../core/hooks/useAppSettings";
import { useHistory } from "react-router";
import { EventDoneForm } from "../../../calendar/components/event-done-form";

interface IActivityItemProps {
  activity: ILeadActivity;
  onPressEdit?: () => void;
  leadId?: string;
  customer?: Customer;
  onUpdateCustomer?: (id: string) => void;
  onReload?: () => void;
}

export const ActivityItem: React.FunctionComponent<IActivityItemProps> = (
  props
) => {
  const masterData = useMasterData(api.settings);

  const p = props.activity;
  const {
    leadState,
    activityMarkAsDone,
    getActivityIcon,
    getAllLeadActivities,
    getLeadActivitiesAll,
    inititateTestDrive,
  } = useLeadActivities(api.lead);

  const { allLeads } = useLead360(api.lead);

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [
    inititateTestDriveButtonDisabled,
    setInitiateTestDriveButtonDisabled,
  ] = useState(false);

  const canModifyActivityStatus = useHasPermission(
    AppPermissions.ModifyActivityStatus
  );
  const canInitiateTestDrive = useHasPermission(
    AppPermissions.InitiateTestDrive
  );

  const canUpdateLeadActivity = useHasPermission(
    AppPermissions.UpdateLeadActivity
  );

  const [activityModal, setActivityModal] = React.useState<{
    isOpen?: boolean;
    activity?: ILeadActivity;
  }>({});

  const [cancelForm, setShowCancelForm] = React.useState<{
    isOpen?: boolean;
    activity?: ILeadActivity;
  }>({});

  const [showMarkAsDoneForm, setShowMarkAsDoneForm] = React.useState<{
    isOpen?: boolean;
    activity?: ILeadActivity;
  }>({});

  const closeTooltip = () => {
    const x: any = document.getElementById("event-list-item-popup");
    if (x) {
      x.style.display = "none";
      setShowCancelForm({});
    }
  };

  const ref = React.useRef<HTMLLIElement>(null);

  const getTarget = (): any => {
    return ReactDOM.findDOMNode(ref.current);
  };

  const {
    performAction: downloadTestDriveForm,
    isPerforming: downloading,
  } = usePerformAction(
    async (id: string) => {
      await api.lead.downloadTestDriveForm(id);
    },
    () => {
      toastr.success("Success", "Downloaded successfully");
    },
    () => {
      toastr.error("Error", "Failed to download");
    }
  );

  const markAsDone = (mileageIn?: string, mileageOut?: string) => {
    activityMarkAsDone(
      leadState?.leadDetails?._id ?? "",
      p?._id ?? "",
      () => {
        // if (props.leadIds?.length) {
        //   getLeadActivitiesAll(props.leadIds || []);
        // } else {
        //   getAllLeadActivities(leadState?.leadDetails?._id || "");
        //   if (!currentLead?.isDeal) {
        //     props.onReload?.();
        //   }
        // }
        props.onReload?.();
      },
      mileageIn,
      mileageOut
    );
  };
  const onMarkAsDone = (activity: ILeadActivity) => {
    markAsDone();
  };

  React.useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event: { target: any }) => {
    if (ref && ref.current && !ref.current?.contains?.(event.target)) {
      setActivityModal({});
    }
  };

  const renderNoEventInformation = () => {
    return showConfirmModal ? (
      <>
        <div
          className="modal fade show in"
          id="exampleModal"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-confirm modal-dialog-centered">
            <div className="modal-content rounded-0">
              <div className="modal-body ">
                <div className="container">
                  <div className="row">
                    <div className="col">
                      <p>
                        Some information is missing in the customer profile for
                        converting Lead to Opportunity. Please update the
                        customer information in order to proceed.
                      </p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-auto mr-auto">
                      <button
                        type="button"
                        className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
                        onClick={() => {
                          setShowConfirmModal(false);
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                    <div className="col-auto">
                      <button
                        type="submit"
                        className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
                        onClick={() => {
                          props.onUpdateCustomer?.(p?._id);
                          setShowConfirmModal(false);
                        }}
                      >
                        Update Profile
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show"></div>
      </>
    ) : (
      <></>
    );
  };

  return (
    <Fragment>
      <li ref={ref} className="d-flex mb-3 position-relative ">
        <div className="activity-icon rounded-circle bg-white shadow d-flex align-items-center justify-content-center mr-2 mt-2 font-xxs">
          <i
            className={
              getActivityIcon(p.type, p.triggeredBy) + " text-gray-500"
            }
          ></i>
        </div>
        <div className="activity-box arrow border rounded p-2 col bg-white">
          <div className="d-flex align-items-center mb-2 p-1">
            {canModifyActivityStatus && (
              <i
                onClick={() => {
                  if (p.status !== "completed") {
                    markAsDone();
                  }
                }}
                className={classnames({
                  "mr-2": true,
                  "icon-tick-round text-gray-500":
                    p.event?.status !== "cancelled",
                  "icon-close-round text-red": p.event?.status === "cancelled",
                  "cursor-pointer": !(
                    p.status === "completed" && !p.isEditable
                  ),
                  "text-green":
                    p.status === "completed" && p.event?.status !== "cancelled",
                  "text-red": moment(p?.event?.startDate).isBefore(moment()),
                })}
              ></i>
            )}

            <span
              className={`font-sm font-weight-semibold ${
                props.onPressEdit &&
                canUpdateLeadActivity &&
                p.status !== "completed"
                  ? ""
                  : ""
              } `}
            >
              {p.title}
            </span>
            {p.status !== "completed" && (
              <>
                <i
                  onClick={() =>
                    setActivityModal({
                      isOpen: true,
                      activity: p,
                    })
                  }
                  className="cursor-pointer d-flex icon-ellipsis ml-auto text-muted"
                ></i>
                {activityModal?.isOpen && (
                  <div
                    style={{ top: 25 }}
                    className="dropdown-menu dropdown-menu-right dropdown-shadow rounded font-sm border-0 in"
                  >
                    {canInitiateTestDrive &&
                      p.title === "test drive" &&
                      !p.testDriveInitiationStatus && (
                        <button
                          onClick={() => {
                            setInitiateTestDriveButtonDisabled(true);
                            inititateTestDrive(p._id, () => {
                              // if (props.leadIds?.length) {
                              //   getLeadActivitiesAll(props.leadIds || []);
                              // } else {
                              //   getAllLeadActivities(
                              //     leadState?.leadDetails?._id || ""
                              //   );
                              //   if (!currentLead?.isDeal) {
                              //     props.onReload?.();
                              //     // history.push(`${RouteKeys.Enquiry}/${currentLead?._id || ''}`);
                              //   }
                              // }
                              setInitiateTestDriveButtonDisabled(false);
                            });
                          }}
                          className="font-xs text-gray-500 cursor-pointer px-3 py-2 dropdown-item"
                          disabled={inititateTestDriveButtonDisabled}
                        >
                          Initiate Test Drive{" "}
                        </button>
                      )}
                    {canModifyActivityStatus && (
                      <>
                        {/* {(p.title !== 'test drive' ||
                            !CannotCancelInitiatedTestDriveStatuses.find(
                              (s) => s === p.testDriveInitiationStatus
                            )) && ( */}
                        <div
                          onClick={() => {
                            setShowCancelForm({
                              isOpen: true,
                              activity: p,
                            });
                            setActivityModal({});
                          }}
                          className="font-xs text-gray-500 cursor-pointer px-3 py-2 dropdown-item"
                        >
                          Mark as Cancelled
                        </div>
                        {/* )} */}
                        {/* {(p.title !== 'test drive' ||
                            p.testDriveInitiationStatus ===
                              TestDriveInititationStatuses.Completed) && ( */}
                        <div
                          onClick={() => {
                            onMarkAsDone(p);
                            setActivityModal({});
                          }}
                          className="font-xs text-gray-500 cursor-pointer px-3 py-2 dropdown-item"
                        >
                          Mark as Done
                        </div>
                        {/* )} */}
                      </>
                    )}
                    {props.onPressEdit &&
                      p.status !== "completed" &&
                      canUpdateLeadActivity &&
                      (p.title !== "test drive" ||
                        !p.testDriveInitiationStatus) && (
                        <div
                          onClick={() => {
                            props.onPressEdit?.();
                            setActivityModal({});
                          }}
                          className="font-xs text-gray-500 cursor-pointer px-3 py-2 dropdown-item"
                        >
                          Edit
                        </div>
                      )}
                  </div>
                )}
              </>
            )}
          </div>
          {p?.event != null ? (
            <>
              {p?.event?.note && (
                <div className="font-xs gutter-5 px-1 pb-1 pt-0 align-items-center ml-0 mb-1">
                  Note :{" "}
                  <span className="text-gray-500 ml-1">{p?.event?.note}</span>
                </div>
              )}
              <div className="row font-xs gutter-5 px-1 pb-1 pt-0 align-items-center">
                {p?.event?.startDate != null && (
                  <div className="col-auto text-gray-500">
                    {formatDate(
                      p.event.startDate,
                      DateFormats.NormalDateFormat
                    )}{" "}
                    at{" "}
                    {formatDate(p.event.startDate, DateFormats.TimeOnlyFormat)}
                  </div>
                )}
                <div className="activity-separator bg-gray-400 rounded-circle mx-1"></div>
                <div className="col-auto text-gray-500">
                  {p?.event?.assignedPerson?.knownAs ||
                    p?.event?.assignedPerson?.name}
                </div>

                {p?.leadTitle && (
                  <>
                    <div className="activity-separator bg-gray-400 rounded-circle mx-1"></div>
                    <div className="col-auto text-gray-500">{p?.leadTitle}</div>
                  </>
                )}
              </div>

              {p.title === "test drive" && (
                <div className="font-xs gutter-5 px-1 pb-1 pt-0 align-items-center ml-0 mb-1">
                  <PdfDownloadButton
                    id={p._id}
                    downloadFn={downloadTestDriveForm}
                  ></PdfDownloadButton>
                </div>
              )}
              {p?.testDriveInitiationStatus && (
                <>
                  {"status" && (
                    <div className="font-xs gutter-5 px-1 pb-1 pt-0 align-items-center ml-0 mb-1">
                      <span className="text-gray-500 ml-1">
                        {`Test Drive ${capitalizeFirstLetter(
                          p.testDriveInitiationStatus
                        )}`}
                      </span>
                    </div>
                  )}

                  {p?.realTimeTestDriveStartTime && (
                    <div className="row font-xs gutter-5 px-1 pb-1 pt-0 align-items-center">
                      <div className="activity-separator bg-gray-400 rounded-circle mx-1"></div>

                      {p?.realTimeTestDriveStartTime && (
                        <div className="col-auto text-gray-500">
                          Start Time:{" "}
                          {formatDate(
                            p.realTimeTestDriveStartTime,
                            DateFormats.NormalDateFormat
                          )}{" "}
                          at{" "}
                          {formatDate(
                            p.realTimeTestDriveStartTime,
                            DateFormats.TimeOnlyFormat
                          )}{" "}
                        </div>
                      )}
                    </div>
                  )}
                  {p?.realTimeTestDriveEndTime && (
                    <div className="row font-xs gutter-5 px-1 pb-1 pt-0 align-items-center">
                      <div className="activity-separator bg-gray-400 rounded-circle mx-1"></div>

                      {p?.realTimeTestDriveEndTime && (
                        <div className="col-auto text-gray-500">
                          End Time:{" "}
                          {formatDate(
                            p.realTimeTestDriveEndTime,
                            DateFormats.NormalDateFormat
                          )}{" "}
                          at{" "}
                          {formatDate(
                            p.realTimeTestDriveEndTime,
                            DateFormats.TimeOnlyFormat
                          )}{" "}
                        </div>
                      )}
                    </div>
                  )}
                  {p?.event?.mileageOut && (
                    <div className="row font-xs gutter-5 px-1 pb-1 pt-0 align-items-center">
                      <div className="activity-separator bg-gray-400 rounded-circle mx-1"></div>
                      {p?.event?.mileageOut && (
                        <div className="col-auto text-gray-500">
                          Mileage Out: {p.event.mileageOut}
                        </div>
                      )}

                      {p?.event?.mileageIn && (
                        <>
                          <div className="activity-separator bg-gray-400 rounded-circle mx-1"></div>
                          <div className="col-auto text-gray-500">
                            <div className="col-auto text-gray-500">
                              Mileage In: {p.event.mileageIn}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </>
              )}
            </>
          ) : (
            <>
              {p?.note && (
                <div className="font-xs gutter-5 px-1 pb-1 pt-0 align-items-center ml-0 mb-1">
                  <span className="text-gray-500 ml-1">{p?.note}</span>
                </div>
              )}
              <div className="row font-xs gutter-5 px-1 pb-1 pt-0 align-items-center">
                {p?.createdAt != null && (
                  <div className="col-auto text-gray-500">
                    {formatDate(p.createdAt, DateFormats.NormalDateFormat)} at{" "}
                    {formatDate(p.createdAt, DateFormats.TimeOnlyFormat)}
                  </div>
                )}
                {p?.createdBy && (
                  <>
                    <div className="activity-separator bg-gray-400 rounded-circle mx-1"></div>
                    <div className="col-auto text-gray-500">
                      {p?.createdBy?.name}
                    </div>
                  </>
                )}

                {p?.leadTitle && (
                  <>
                    <div className="activity-separator bg-gray-400 rounded-circle mx-1"></div>
                    <div className="col-auto text-gray-500">{p?.leadTitle}</div>
                  </>
                )}
              </div>
            </>
          )}
          {cancelForm?.isOpen && (
            <Overlay
              rootClose
              target={getTarget}
              show={cancelForm?.isOpen}
              flip
              placement="right"
              onHide={closeTooltip}
            >
              <Popover id="activity-item-popup">
                <Popover.Content>
                  <div className="calendar-info-popover">
                    <EventCancelForm
                      eventId={cancelForm?.activity?.event?._id || ""}
                      onSuccess={() => {
                        // if (props.leadIds?.length) {
                        //   getLeadActivitiesAll(props.leadIds || []);
                        // } else {
                        //   getAllLeadActivities(
                        //     leadState?.leadDetails?._id || ""
                        //   );
                        // }
                        props.onReload?.();
                        setShowCancelForm({});
                      }}
                      onCancel={() => {
                        setShowCancelForm({});
                      }}
                    ></EventCancelForm>
                  </div>
                </Popover.Content>
              </Popover>
            </Overlay>
          )}

          {showMarkAsDoneForm.isOpen && (
            <Overlay
              rootClose
              target={getTarget}
              show={showMarkAsDoneForm?.isOpen}
              flip
              placement="right"
              onHide={closeTooltip}
            >
              <Popover id="activity-item-popup">
                <Popover.Content>
                  <div className="calendar-info-popover">
                    <EventDoneForm
                      eventId={cancelForm?.activity?.event?._id || ""}
                      onSuccess={() => {
                        // if (props.leadIds?.length) {
                        //   getLeadActivitiesAll(props.leadIds || []);
                        // } else {
                        //   getAllLeadActivities(
                        //     leadState?.leadDetails?._id || ""
                        //   );
                        // }

                        setShowMarkAsDoneForm({});
                      }}
                      onCancel={() => {
                        setShowMarkAsDoneForm({});
                      }}
                      markAsDone={markAsDone}
                    ></EventDoneForm>
                  </div>
                </Popover.Content>
              </Popover>
            </Overlay>
          )}
        </div>
        {renderNoEventInformation()}
      </li>
    </Fragment>
  );
};
